// extracted by mini-css-extract-plugin
export var actionButtonsContainer = "_o7-0";
export var animationContainer = "_o7-1";
export var itemPrice = "_o7-a";
export var itemizedContent = "_o7-9";
export var itemizedHeader = "_o7-7";
export var itemizedRow = "_o7-8";
export var itemizedSection = "_o7-6";
export var modalContent = "_o7-2";
export var orderName = "_o7-3";
export var refundOption = "_o7-4";
export var refundOptionsContainer = "_o7-5";
export var shippingLabel = "_o7-b";
export var totalRow = "_o7-c";